import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { getContainerSize } from '../utils/size';
import { deepAssign } from '../utils/helper';
// Keys can specified by new Chart({...}).
// Keys can bubble form mark-level options to view-level options.
export var VIEW_KEYS = ['width', 'height', 'depth', 'padding', 'paddingLeft', 'paddingRight', 'paddingBottom', 'paddingTop', 'inset', 'insetLeft', 'insetRight', 'insetTop', 'insetBottom', 'margin', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom', 'autoFit', 'theme', 'title'];
export function normalizeContainer(container) {
  if (container === undefined) return document.createElement('div');
  if (typeof container === 'string') {
    var node = document.getElementById(container);
    return node;
  }
  return container;
}
export function removeContainer(container) {
  var parent = container.parentNode;
  if (parent) {
    parent.removeChild(container);
  }
}
export function normalizeRoot(node) {
  if (node.type !== null) return node;
  var root = node.children[node.children.length - 1];
  var _iterator = _createForOfIteratorHelper(VIEW_KEYS),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      root.attr(key, node.attr(key));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return root;
}
export function valueOf(node) {
  return Object.assign(Object.assign({}, node.value), {
    type: node.type
  });
}
export function sizeOf(options, container) {
  var autoFit = options.autoFit;
  if (autoFit) return getContainerSize(container);
  var _options$width = options.width,
    width = _options$width === void 0 ? 640 : _options$width,
    _options$height = options.height,
    height = _options$height === void 0 ? 480 : _options$height,
    _options$depth = options.depth,
    depth = _options$depth === void 0 ? 0 : _options$depth;
  return {
    width: width,
    height: height,
    depth: depth
  };
}
export function optionsOf(node) {
  var root = normalizeRoot(node);
  var discovered = [root];
  var nodeValue = new Map();
  nodeValue.set(root, valueOf(root));
  while (discovered.length) {
    var _node = discovered.pop();
    var value = nodeValue.get(_node);
    var _node$children = _node.children,
      children = _node$children === void 0 ? [] : _node$children;
    var _iterator2 = _createForOfIteratorHelper(children),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var child = _step2.value;
        var childValue = valueOf(child);
        var _value$children = value.children,
          _children = _value$children === void 0 ? [] : _value$children;
        _children.push(childValue);
        discovered.push(child);
        nodeValue.set(child, childValue);
        value.children = _children;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return nodeValue.get(root);
}
function isMark(type, mark) {
  if (typeof type === 'function') return true;
  return new Set(Object.keys(mark)).has(type);
}
function normalizeRootOptions(node, options, previousType, marks) {
  var oldType = node.type;
  var _options$type = options.type,
    type = _options$type === void 0 ? previousType || oldType : _options$type;
  if (type === 'view') return options;
  if (!isMark(type, marks)) return options;
  var view = {
    type: 'view'
  };
  var mark = Object.assign({}, options);
  var _iterator3 = _createForOfIteratorHelper(VIEW_KEYS),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var key = _step3.value;
      if (mark[key] !== undefined) {
        view[key] = mark[key];
        delete mark[key];
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return Object.assign(Object.assign({}, view), {
    children: [mark]
  });
}
function typeCtor(type, mark, composition) {
  if (typeof type === 'function') return mark.mark;
  var node = Object.assign(Object.assign({}, mark), composition);
  var ctor = node[type];
  if (!ctor) throw new Error("Unknown mark: ".concat(type, "."));
  return ctor;
}
// Create node from options.
function createNode(options, mark, composition) {
  var type = options.type,
    children = options.children,
    value = __rest(options, ["type", "children"]);
  var Ctor = typeCtor(type, mark, composition);
  var node = new Ctor();
  node.value = value;
  // @ts-ignore
  node.type = type;
  return node;
}
// Update node by options.
function updateNode(node, newOptions) {
  var type = newOptions.type,
    children = newOptions.children,
    value = __rest(newOptions, ["type", "children"]);
  if (node.type === type || type === undefined) {
    // Update node.
    deepAssign(node.value, value);
  } else if (typeof type === 'string') {
    // Transform node.
    node.type = type;
    node.value = value;
  }
}
// Create a nested node tree from newOptions, and append it to the parent.
function appendNode(parent, newOptions, mark, composition) {
  if (!parent) return;
  var discovered = [[parent, newOptions]];
  while (discovered.length) {
    var _discovered$shift = discovered.shift(),
      _discovered$shift2 = _slicedToArray(_discovered$shift, 2),
      _parent = _discovered$shift2[0],
      nodeOptions = _discovered$shift2[1];
    var node = createNode(nodeOptions, mark, composition);
    if (Array.isArray(_parent.children)) _parent.push(node);
    var children = nodeOptions.children;
    if (Array.isArray(children)) {
      var _iterator4 = _createForOfIteratorHelper(children),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var child = _step4.value;
          discovered.push([node, child]);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }
}
// Update node tree from options.
export function updateRoot(node, options, definedType, mark, composition) {
  var rootOptions = normalizeRootOptions(node, options, definedType, mark);
  var discovered = [[null, node, rootOptions]];
  while (discovered.length) {
    var _discovered$shift3 = discovered.shift(),
      _discovered$shift4 = _slicedToArray(_discovered$shift3, 3),
      parent = _discovered$shift4[0],
      oldNode = _discovered$shift4[1],
      newNode = _discovered$shift4[2]; // If there is no oldNode, create a node tree directly.
    if (!oldNode) {
      appendNode(parent, newNode, mark, composition);
    } else if (!newNode) {
      oldNode.remove();
    } else {
      updateNode(oldNode, newNode);
      var newChildren = newNode.children;
      var oldChildren = oldNode.children;
      if (Array.isArray(newChildren) && Array.isArray(oldChildren)) {
        // Only update node specified in newChildren,
        // the extra oldChildren will remain still.
        var n = Math.max(newChildren.length, oldChildren.length);
        for (var i = 0; i < n; i++) {
          var newChild = newChildren[i];
          var oldChild = oldChildren[i];
          discovered.push([oldNode, oldChild, newChild]);
        }
      }
    }
  }
}
export function createEmptyPromise() {
  var reject;
  var resolve;
  var cloned = new Promise(function (res, rej) {
    resolve = res;
    reject = rej;
  });
  return [cloned, resolve, reject];
}